import inputData from './inputData/market-research-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'market-research-survey',
  title: 'Market Research Survey',
  description: 'Uncover valuable insights about your audience and sharpen your product-market fit with clear, actionable data.',
  image: '/images/templates/market-research-survey.png',
  tags: ['get-feedback', 'marketing', 'product'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

